module.exports = __webpack_public_path__ + "img/season-dial.f74e6d16.png";